import { useState } from 'react'
import { t } from '../lib/i18n'
import { currentTheme, setTheme } from '../lib/theme'
import Icon from './Icon'

/** One button: shows what pressing it switches TO, not what is showing now. */
export default function ThemeToggle() {
  const [theme, set] = useState(currentTheme)
  const next = theme === 'dark' ? 'light' : 'dark'
  const label = next === 'light' ? t('theme.light') : t('theme.dark')
  return (
    <button
      className="theme-toggle"
      onClick={() => { setTheme(next); set(next) }}
      aria-label={label}
      title={label}
    >
      <Icon name={next === 'light' ? 'sunrise' : 'moon'} size={19} />
    </button>
  )
}
